import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=7c3f1deb&scoped=true&"
var script = {}
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=7c3f1deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3f1deb",
  null
  
)

export default component.exports